import { render, staticRenderFns } from "./view-pharmacy-orders-discount-new.vue?vue&type=template&id=2bf8742b"
import script from "./view-pharmacy-orders-discount-new.vue?vue&type=script&lang=js"
export * from "./view-pharmacy-orders-discount-new.vue?vue&type=script&lang=js"
import style0 from "./view-pharmacy-orders-discount-new.vue?vue&type=style&index=0&id=2bf8742b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports